import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { PageHeader, UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';
import { Fetcher, useFetcher } from '../../../utils';
import { RaffleListItem } from './raffleListItem';

export const RaffleList: FC = () => {
  const { ts } = useTranslation();
  const history = useHistory();
  const fetcher = useFetcher(async () => await api.getRaffles());
  return (
    <UserStateComponent>
      {fetcher.data ? (
        <>
          <PageHeader>{ts('common.gatekeeping')}</PageHeader>
          <div>
            <Button
              color="primary"
              id="createRaffle"
              onClick={() => {
                history.push('/housekeeping/gatekeeping/new');
              }}
            >
              {ts('create_new_silo')}
            </Button>
          </div>
          <hr />
          <Row className="justify-content-center">
            {fetcher.data.map((raffle) => (
              <Col className="mb-3" key={raffle.id} lg={7} xs={12}>
                <RaffleListItem raffle={raffle} />
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <Fetcher result={fetcher} />
      )}
    </UserStateComponent>
  );
};
